// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllPinsNotRegisteredDealers = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_PINS_NOT_REGISTERED_DEALERS
});

export const selectPinsNotRegisteredDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.SELECT_PINS_NOT_REGISTERED_DEALER
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.TOGGLE_ALL_PINS_NOT_REGISTERED_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/action-creators/select-dealer.js